import { z } from "zod";
import { defineNotificationHandler } from "./types";

const ConversationEndedSchema = z.object({
  conversationId: z.string(),
  employerName: z.string(),
});

export const conversationEndedHandler = defineNotificationHandler({
  type: "conversation.ended",
  icon: "message",
  title(metadata) {
    const employerName =
      typeof metadata.employerName === "string" && metadata.employerName.trim()
        ? metadata.employerName
        : undefined;
    return `Conversation ended by ${employerName ?? "employer"}`;
  },
  description() {
    return "A conversation has been closed.";
  },
  schema: ConversationEndedSchema,
  buildNotificationPayload(data, _ctx) {
    return {
      metadata: {
        conversationId: data.conversationId,
        employerName: data.employerName,
      },
      links: {
        href: `/conversations/${data.conversationId}`,
        label: "View conversation",
      },
    };
  },
});
